import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";
import {
  Button,
  Progress,
  Modal,
  ModalBody,
  ModalFooter,
  Col,
  Row,
  Container,
  ModalHeader,
  FormGroup,
  Input,
  Label,
  UncontrolledTooltip
} from "reactstrap";
import HttpUtil from "../../Util/httpUtil";
import Config from "../../Util/config";
import PrettyCheckbox from "../Common/PrettyCheckbox";
import { formataData, validarCNPJ, formataCurrency } from "../../BaseFunctions";
import TooltippedCel from "../Common/TooltippedCel";
import InputMask from "react-input-mask";
import { ModalAvisoContext } from "../../Context/ModalAvisoContext";
import "./RemessaBancariaAvisoSelecionarTodas.scss";

class RemessaBancariaAvisoSelecionarTodas extends Component {
  static contextType = ModalAvisoContext;
  constructor(props) {
    super(props);

    this.defaultState = {
      isOpen: false,
      loading: false,
      intQtdeRegistros: 0,
      strEmitente: "",
      listaSelecionada: []
    };

    this.state = {
      ...this.defaultState
    };
  }

  toggleModal = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  openModal = async () => {
    const res = await HttpUtil.eco_GET(
      `${Config.urls.API_URL_BASE}Documento/RemessaBancaria/BuscarGuiasEmitidasPorCnpj/${this.props.value[0].cnpjEmissor}`
    );

    this.setState({intQtdeRegistros: res.data.length});
    this.setState({strEmitente: res.data[0].razaoSocialEmissor});
    this.setState({listaSelecionada: res.data.map(item => (
      {
        id:item.id,
        razaoSocialEmissor:item.razaoSocialEmissor,
        pagamento:formataData(item.data),
        uf:item.uf,
        valor:item.valor
      }))});
    this.setState({ isOpen: true });
  };

  closeModal = () => {
    this.setState({
      ...this.defaultState
    });
  };

  emiteIds = () => {
    this.props.onAccept(this.state.listaSelecionada)
    this.closeModal();
  };

  render() {
    return (
      <main id="avisoremessa">
        <Modal
          centered={true}
          isOpen={this.state.isOpen}
          onClosed={this.props.onClosed}
          backdrop="static"
          size="xl"
        >
          <ModalHeader style={{ background: "#31597B", color: "#FFF" }}>
            ATENÇÃO!!!
          </ModalHeader>
          <ModalBody>
            <div className="formField formField--fit" style={{width:"100%", textAlign: "center"}}>
              <Label style={{ fontSize: "18px" }}>
                  Esta ação irá gerar um arquivo de remessa com <strong>{this.state.intQtdeRegistros}</strong> guia(s) referente ao emitente <strong>{this.state.strEmitente}</strong>.
              </Label>
              <br/>
              <Label style={{ fontSize: "18px" }}>
                  <strong>Deseja continuar ?</strong>
              </Label>
            </div>
          </ModalBody>
          <ModalFooter>
            <Container>
              <Row className="justify-content-end">
                <Col xs="auto">
                  <Button color="info" onClick={() => this.closeModal()}>
                    Fechar
                  </Button>
                </Col>
                <Col xs="auto">
                  <Button color="primary" onClick={() => this.emiteIds()}>
                    Continuar
                  </Button>
                </Col>
              </Row>
            </Container>
          </ModalFooter>
        </Modal>
      </main>
    );
  }
}

RemessaBancariaAvisoSelecionarTodas.propTypes = {
  value: PropTypes.array,
  onClosed: PropTypes.func.isRequired
};

export default RemessaBancariaAvisoSelecionarTodas;
